import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {UtilService} from "./util.service";
import {OktaAuthService} from "@okta/okta-angular";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RouteResolverService implements Resolve<any>{
  constructor(private router: Router, private oktaAuth: OktaAuthService, private utilService: UtilService, private http: HttpClient) { }
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<any> | Promise<any> | any> {
    if(!this.utilService.userType){
      await this.oktaAuth.getUser().then(data => {
        this.utilService.setUserType(data.userType);
      })
    }

    const rolePaths = this.utilService.routeRoles;

    // if(!route.routeConfig.path){
    //
    //   if(Object.keys(rolePaths).includes(this.utilService.userType))
    //     this.router.navigate([`/${rolePaths[this.utilService.userType][0]}`]);
    //   else
    //     this.router.navigate(['/quick-quotes']);
    //   return;
    // }
    // if(Object.keys(rolePaths).includes(this.utilService.userType) && rolePaths[this.utilService.userType].includes(route.routeConfig.path)){
    //   return;
    // }else{
    //   this.router.navigate(['/404']);
    // }

    if(this.utilService && !this.utilService.userRoles.length){
      let url = environment.apiUrl + 'security/authorization'
      await this.http.get(url).toPromise().then(res => {
        this.utilService.setUserRoles(res as any[]);
      })
    }

    let redirectPath: string = "quick-quotes";
    let sequencePaths: string[] = ['dashboard', 'quick-quotes', 'admin'];
    if(!this.utilService.accessPaths.length){
      let accessPaths: string[] = [];
      for(let role of rolePaths.roles){
        for(let userRole of this.utilService.userRoles){
          if(userRole.role == role.role){
            accessPaths.push(role.path);
            if(role.path == 'custom-deals'){
              accessPaths = accessPaths.concat(['rfp-history', 'contract-history', 'new-request']);
            }
            if(role.path == 'quick-quotes'){
              accessPaths.push('price-history');
            }
            if(role.path == 'contract-templates'){
              accessPaths.push('disable-contract-download');
            }
            break;
          }
        }
      }
      this.utilService.setAccessPaths(accessPaths);
    }
    if(!route.routeConfig.path){

      for(let path of sequencePaths){
        if(this.utilService.accessPaths.includes(path)){
          redirectPath = path;
          break;
        }
      }
      this.router.navigate([`/${redirectPath}`]);
      return;
    }
    if(this.utilService.accessPaths.includes(route.routeConfig.path)){
      return;
    }else{
      this.router.navigate(['/404']);
    }
  }
}
